function toNumber(str) {
  if (str === undefined || str === null) return 0;
  // ensure string
  str = String(str).trim();

  str = str.replace(/\s+/g, '')     //Remove spaces (thousands)
           .replace(',', '.')      //Replace comma with dot
           .replace(/[^\d.\-]/g, ''); // Remove any other chars

  var n = parseFloat(str);
  return isFinite(n) ? n : 0;
}


function parsePrice(value) {
    if (!value) return 0;
    return parseFloat(
        value
            .toString()
            .replace(/\s+/g, '')   // remove thousands separators (spaces)
            .replace(',', '.')     // convert decimal comma to dot
    ) || 0;
}


// Sum values from a NodeList or array of inputs
function sumValues(nodeList) {
    return Array.from(nodeList).reduce((sum, input) => sum + parsePrice(input.value), 0);
}

function priceDifference(price1, price2) {
    let colorclass = 'issame';
    let prefix = '';
    let difference = 0;

    if (price2 === 0) {
        var differenceTable = ['0', colorclass];
        return differenceTable;
    }

    if (price1 < price2) {
        difference = ((price2 - price1) / price2) * 100;
        prefix = '-';
        colorclass = 'issmaller';
    } else if (price1 > price2) {
        difference = ((price1 - price2) / price2) * 100;
        prefix = '+';
        colorclass = 'isbigger';
    }

    var differenceStr = difference.toLocaleString('fi-FI', { minimumFractionDigits: 0, maximumFractionDigits: 1 });
    differenceStr = prefix + differenceStr;
    var differenceTable = [differenceStr, colorclass];

    return differenceTable;
}

function calculateYritysmaksu(totalKilos) {

    //VALUES
    const datalabels = document.querySelector('#datalabels');
    const minlabel = datalabels.dataset.minLabel;
    const maxlabel = datalabels.dataset.maxLabel;

    const c1Yrityspalvelu = document.querySelector('#yrityspalvelumaksu__yritys1');
    const c1YrityspalveluValue = parseFloat(c1Yrityspalvelu.dataset.value);
    const c1YrityspalveluMin = parseFloat(c1Yrityspalvelu.dataset.min);
    const c1YrityspalveluMax = parseFloat(c1Yrityspalvelu.dataset.max);

    const c2Yrityspalvelu = document.querySelector('#yrityspalvelumaksu__yritys2');
    const c2YrityspalveluValue = parseFloat(c2Yrityspalvelu.dataset.value);
    const c2YrityspalveluMin = parseFloat(c2Yrityspalvelu.dataset.min);
    const c2YrityspalveluMax = parseFloat(c2Yrityspalvelu.dataset.max);

    //INPUTIT
    const c1yrityspalvelumaksuInput = document.querySelector('#yrityspalvelumaksu input[name="company1-kuluttaja"]');
    const c1yrityspalvelumaksuText = document.querySelector('#yrityspalvelumaksu .company1-kuluttaja-price');
    const c2yrityspalvelumaksuInput = document.querySelector('#yrityspalvelumaksu input[name="company2-kuluttaja"]');
    const c2yrityspalvelumaksuText = document.querySelector('#yrityspalvelumaksu .company2-kuluttaja-price');


    //Check yritys 1
    let c1YrityspalveluPrice = totalKilos * c1YrityspalveluValue;
    if (c1YrityspalveluPrice <= c1YrityspalveluMin) {
        c1YrityspalveluPrice = c1YrityspalveluMin;
        c1yrityspalvelumaksuText.textContent = minlabel;
    } else if (c1YrityspalveluPrice >= c1YrityspalveluMax) {
        c1YrityspalveluPrice = c1YrityspalveluMax;
        c1yrityspalvelumaksuText.textContent = maxlabel;
    } else {
        c1yrityspalvelumaksuText.textContent = c1YrityspalveluValue.toString().replace('.', ',') + ' € / kg';
    }
    c1yrityspalvelumaksuInput.value = c1YrityspalveluPrice.toFixed(2).replace('.', ',');

    //Check yritys 2
    let c2YrityspalveluPrice = totalKilos * c2YrityspalveluValue;
    if (c2YrityspalveluPrice <= c2YrityspalveluMin) {
        c2YrityspalveluPrice = c2YrityspalveluMin;
        c2yrityspalvelumaksuText.textContent = minlabel;
    } else if (c2YrityspalveluPrice >= c2YrityspalveluMax) {
        c2YrityspalveluPrice = c2YrityspalveluMax;
        c2yrityspalvelumaksuText.textContent = maxlabel;
    } else {
        c2yrityspalvelumaksuText.textContent = c2YrityspalveluValue.toString().replace('.', ',') + ' € / kg';
    }
    c2yrityspalvelumaksuInput.value = c2YrityspalveluPrice.toFixed(2).replace('.', ',');

}

function calculateTotalsByMaterial() {

    function calculateKilosByMaterial(materialClass, summarySelector) {

        const taulukkoryhma = document.querySelector(`.hintalaskuri__taulukko__ryhma.${materialClass}`);

        //KILOT
        const kuluttajakilot = taulukkoryhma.querySelectorAll('.hintalaskuririvi.enabled input[name="kuluttajakilot"]');
        const yrityskilot = taulukkoryhma.querySelectorAll('.hintalaskuririvi.enabled input[name="yrityskilot"]');
        const yhteenvetoYhteensa = document.querySelector(summarySelector);

        if (kuluttajakilot && yrityskilot && yhteenvetoYhteensa) {
            const kuluttajakilotyhteensa = yhteenvetoYhteensa.querySelector('input[name="kuluttajakilot-yhteensa"]');
            const yrityskilotyhteensa = yhteenvetoYhteensa.querySelector('input[name="yrityskilot-yhteensa"]');
            const kaikkikilotyhteensa = yhteenvetoYhteensa.querySelector('input[name="kaikkikilot-yhteensa"]');

            //SUMMAUS
            const kuluttajaTotal = sumValues(kuluttajakilot);
            const yritysTotal = sumValues(yrityskilot);

            //VALUET PAIKOILLEEN
            kuluttajakilotyhteensa.value = kuluttajaTotal.toLocaleString('fi-FI', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
            yrityskilotyhteensa.value = yritysTotal.toLocaleString('fi-FI', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
            kaikkikilotyhteensa.value = (kuluttajaTotal + yritysTotal).toLocaleString('fi-FI', { minimumFractionDigits: 0, maximumFractionDigits: 0 });


            const kaikkiValue = Number(kaikkikilotyhteensa.value.replace(/\D/g, ''));
            const yhteenvetorivi = kaikkikilotyhteensa.closest('.yhteenvetorivi');
            let isZero = kaikkiValue === 0;
            yhteenvetorivi.classList.toggle('emptyyhteenvetorivi', isZero);

        }

        //HINNAT
        const company1Kuluttaja = taulukkoryhma.querySelectorAll('.hintalaskuririvi.enabled input[name="company1-kuluttaja"]');
        const company1Yritys = taulukkoryhma.querySelectorAll('.hintalaskuririvi.enabled input[name="company1-yritys"]');
        const company2Kuluttaja = taulukkoryhma.querySelectorAll('.hintalaskuririvi.enabled input[name="company2-kuluttaja"]');
        const company2Yritys = taulukkoryhma.querySelectorAll('.hintalaskuririvi.enabled input[name="company2-yritys"]');

        if (company1Kuluttaja && company1Yritys && company2Kuluttaja && company2Yritys && yhteenvetoYhteensa) {
            const company1KuluttajaYhteensa = yhteenvetoYhteensa.querySelector('input[name="company1-kuluttaja-yhteensa"]');
            const company1YritysYhteensa = yhteenvetoYhteensa.querySelector('input[name="company1-yritys-yhteensa"]');
            const company1Yhteensa = yhteenvetoYhteensa.querySelector('input[name="company1-yhteensa"]');

            const company2KuluttajaYhteensa = yhteenvetoYhteensa.querySelector('input[name="company2-kuluttaja-yhteensa"]');
            const company2YritysYhteensa = yhteenvetoYhteensa.querySelector('input[name="company2-yritys-yhteensa"]');
            const company2Yhteensa = yhteenvetoYhteensa.querySelector('input[name="company2-yhteensa"]');

            const eroKuluttaja = yhteenvetoYhteensa.querySelector('input[name="ero-kuluttaja"]');
            const eroYritys = yhteenvetoYhteensa.querySelector('input[name="ero-yritys"]');
            const eroYhteensa = yhteenvetoYhteensa.querySelector('input[name="ero-yhteensa"]');

            //SUMMAUS
            const company1KuluttajaTotal = sumValues(company1Kuluttaja);
            const company1YritysTotal = sumValues(company1Yritys);
            const company1Total = sumValues(company1Kuluttaja) + sumValues(company1Yritys);

            const company2KuluttajaTotal = sumValues(company2Kuluttaja);
            const company2YritysTotal = sumValues(company2Yritys);
            const company2Total = sumValues(company2Kuluttaja) + sumValues(company2Yritys);

            //EROT
            var kuluttajaPriceDifference = priceDifference(company1KuluttajaTotal, company2KuluttajaTotal);
            var yritysPriceDifference = priceDifference(company1YritysTotal, company2YritysTotal);
            var yhteensaPriceDifference = priceDifference(company1Total, company2Total);

            var kuluttajaEro = kuluttajaPriceDifference[0];
            var yritysEro = yritysPriceDifference[0];
            var yhteensaEro = yhteensaPriceDifference[0];


            //VALUET PAIKOILLEEN
            company1KuluttajaYhteensa.value = company1KuluttajaTotal.toLocaleString('fi-FI', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            company1YritysYhteensa.value = company1YritysTotal.toLocaleString('fi-FI', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            company1Yhteensa.value = company1Total.toLocaleString('fi-FI', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

            company2KuluttajaYhteensa.value = company2KuluttajaTotal.toLocaleString('fi-FI', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            company2YritysYhteensa.value = company2YritysTotal.toLocaleString('fi-FI', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            company2Yhteensa.value = company2Total.toLocaleString('fi-FI', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

            eroKuluttaja.value = kuluttajaEro;
            eroKuluttaja.classList.remove('issame', 'issmaller', 'isbigger');
            eroKuluttaja.classList.add(kuluttajaPriceDifference[1]);

            eroYritys.value = yritysEro;
            eroYritys.classList.remove('issame', 'issmaller', 'isbigger');
            eroYritys.classList.add(yritysPriceDifference[1]);

            eroYhteensa.value = yhteensaEro;
            eroYhteensa.classList.remove('issame', 'issmaller', 'isbigger');
            eroYhteensa.classList.add(yhteensaPriceDifference[1]);

        }

    }



    calculateKilosByMaterial('hintalaskuri-paperikuitu.enabled', '.yhteenveto-paperikuitu');
    calculateKilosByMaterial('hintalaskuri-muovi.enabled', '.yhteenveto-muovi');
    calculateKilosByMaterial('hintalaskuri-metalli.enabled', '.yhteenveto-metalli');
    calculateKilosByMaterial('hintalaskuri-lasi.enabled', '.yhteenveto-lasi');
    calculateKilosByMaterial('hintalaskuri-puu.enabled', '.yhteenveto-puu');

}



function calculateTotalKilos() {
    //TAULUKON KENTÄT
    const kuluttajakilot = document.querySelectorAll('.hintalaskuri__yhteenveto input[name="kuluttajakilot-yhteensa"]');
    const yrityskilot = document.querySelectorAll('.hintalaskuri__yhteenveto input[name="yrityskilot-yhteensa"]');

    //YHTEENSÄ KENTÄT
    const yhteenvetoYhteensa = document.querySelector('.yhteenveto-yhteensa');
    const kuluttajakilotyhteensa = yhteenvetoYhteensa.querySelector('input[name="kaikki-kuluttajakilot-yhteensa"]');
    const yrityskilotyhteensa = yhteenvetoYhteensa.querySelector('input[name="kaikki-yrityskilot-yhteensa"]');
    const kaikkikilotyhteensa = yhteenvetoYhteensa.querySelector('input[name="kaikki-kaikkikilot-yhteensa"]');


    //SUMMAUS
    const kuluttajaTotal = sumValues(kuluttajakilot);
    const yritysTotal = sumValues(yrityskilot);

    //VALUET PAIKOILLEEN
    kuluttajakilotyhteensa.value = kuluttajaTotal.toLocaleString('fi-FI', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    yrityskilotyhteensa.value = yritysTotal.toLocaleString('fi-FI', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    kaikkikilotyhteensa.value = (kuluttajaTotal + yritysTotal).toLocaleString('fi-FI', { minimumFractionDigits: 0, maximumFractionDigits: 0 });

    calculateYritysmaksu(kuluttajaTotal + yritysTotal);

}



function calculateTotalPrices() {

    //TAULUKON KENTÄT
    const allCompany1Maksut = document.querySelectorAll('.hintalaskuri__taulukko__ryhma.enabled.hintalaskuri-yritysmaksut .hintalaskuririvi.enabled input[name="company1-kuluttaja"]');
    const allCompany2Maksut = document.querySelectorAll('.hintalaskuri__taulukko__ryhma.enabled.hintalaskuri-yritysmaksut .hintalaskuririvi.enabled input[name="company2-kuluttaja"]');

    const allCompany1Kuluttaja = document.querySelectorAll('.hintalaskuri__yhteenveto .yhteenvetorivi:not(.yhteenveto-yhteensa) input[name="company1-kuluttaja-yhteensa"]');
    const allCompany1Yritys = document.querySelectorAll('.hintalaskuri__yhteenveto .yhteenvetorivi:not(.yhteenveto-yhteensa) input[name="company1-yritys-yhteensa"]');
    const allCompany2Kuluttaja = document.querySelectorAll('.hintalaskuri__yhteenveto .yhteenvetorivi:not(.yhteenveto-yhteensa) input[name="company2-kuluttaja-yhteensa"]');
    const allCompany2Yritys = document.querySelectorAll('.hintalaskuri__yhteenveto .yhteenvetorivi:not(.yhteenveto-yhteensa) input[name="company2-yritys-yhteensa"]');


    //YHTEENSÄ KENTÄT
    const yhteenvetoYhteensa = document.querySelector('.yhteenveto-yhteensa');
    const company1MaksutYhteensa = yhteenvetoYhteensa.querySelector('input[name="company1-all-yhteensa"]');
    const company2MaksutYhteensa = yhteenvetoYhteensa.querySelector('input[name="company2-all-yhteensa"]');

    const company1KuluttajaYhteensa = yhteenvetoYhteensa.querySelector('input[name="company1-kuluttaja-yhteensa"]');
    const company1YritysYhteensa = yhteenvetoYhteensa.querySelector('input[name="company1-yritys-yhteensa"]');
    const company1Yhteensa = yhteenvetoYhteensa.querySelector('input[name="company1-yhteensa"]');

    const company2KuluttajaYhteensa = yhteenvetoYhteensa.querySelector('input[name="company2-kuluttaja-yhteensa"]');
    const company2YritysYhteensa = yhteenvetoYhteensa.querySelector('input[name="company2-yritys-yhteensa"]');
    const company2Yhteensa = yhteenvetoYhteensa.querySelector('input[name="company2-yhteensa"]');

    const eroKuluttaja = yhteenvetoYhteensa.querySelector('input[name="ero-kuluttaja"]');
    const eroYritys = yhteenvetoYhteensa.querySelector('input[name="ero-yritys"]');
    const eroYhteensa = yhteenvetoYhteensa.querySelector('input[name="ero-yhteensa"]');
    const eroAllYhteensa = yhteenvetoYhteensa.querySelector('input[name="ero-all-yhteensa"]');


    //SUMMAUS
    const company1KuluttajaTotal = sumValues(allCompany1Kuluttaja);
    const company1YritysTotal = sumValues(allCompany1Yritys);
    const company1Total = sumValues(allCompany1Kuluttaja) + sumValues(allCompany1Yritys);

    const company2KuluttajaTotal = sumValues(allCompany2Kuluttaja);
    const company2YritysTotal = sumValues(allCompany2Yritys);
    const company2Total = sumValues(allCompany2Kuluttaja) + sumValues(allCompany2Yritys);

    const company1MaksutTotal = sumValues(allCompany1Maksut) + company1Total;
    const company2MaksutTotal = sumValues(allCompany2Maksut) + company2Total;

    //EROT
    var kuluttajaPriceDifference = priceDifference(company1KuluttajaTotal, company2KuluttajaTotal);
    var yritysPriceDifference = priceDifference(company1YritysTotal, company2YritysTotal);
    var yhteensaPriceDifference = priceDifference(company1Total, company2Total);
    var allYhteensaPriceDifference = priceDifference(company1MaksutTotal, company2MaksutTotal)

    var kuluttajaEro = kuluttajaPriceDifference[0];
    var yritysEro = yritysPriceDifference[0];
    var yhteensaEro = yhteensaPriceDifference[0];
    var allYhteensaEro = allYhteensaPriceDifference[0];

    //VALUET PAIKOILLEEN
    company1MaksutYhteensa.value = company1MaksutTotal.toLocaleString('fi-FI', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    company2MaksutYhteensa.value = company2MaksutTotal.toLocaleString('fi-FI', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

    company1KuluttajaYhteensa.value = company1KuluttajaTotal.toLocaleString('fi-FI', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    company1YritysYhteensa.value = company1YritysTotal.toLocaleString('fi-FI', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    company1Yhteensa.value = company1Total.toLocaleString('fi-FI', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

    company2KuluttajaYhteensa.value = company2KuluttajaTotal.toLocaleString('fi-FI', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    company2YritysYhteensa.value = company2YritysTotal.toLocaleString('fi-FI', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    company2Yhteensa.value = company2Total.toLocaleString('fi-FI', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

    eroKuluttaja.value = kuluttajaEro;
    eroKuluttaja.classList.remove('issame', 'issmaller', 'isbigger');
    eroKuluttaja.classList.add(kuluttajaPriceDifference[1]);

    eroYritys.value = yritysEro;
    eroYritys.classList.remove('issame', 'issmaller', 'isbigger');
    eroYritys.classList.add(yritysPriceDifference[1]);

    eroYhteensa.value = yhteensaEro;
    eroYhteensa.classList.remove('issame', 'issmaller', 'isbigger');
    eroYhteensa.classList.add(yhteensaPriceDifference[1]);

    eroAllYhteensa.value = allYhteensaEro;
    eroAllYhteensa.classList.remove('issame', 'issmaller', 'isbigger');
    eroAllYhteensa.classList.add(allYhteensaPriceDifference[1]);

}



function calculatePrices() {

    const hintalaskuririvit = document.querySelectorAll('.hintalaskuri__taulukko__ryhma.enabled:not(.hintalaskuri-yritysmaksut) .hintalaskuririvi.enabled');

    hintalaskuririvit.forEach(row => {
        // Get kilo inputs
        var yritysKilotInput = row.querySelector('input[name="yrityskilot"]');
        var kuluttajaKilotInput = row.querySelector('input[name="kuluttajakilot"]');

/*         var yritysKilot = yritysKilotInput ? parseFloat(yritysKilotInput.value) || 0 : 0;
        var kuluttajaKilot = kuluttajaKilotInput ? parseFloat(kuluttajaKilotInput.value) || 0 : 0; */
        // Use the helper to convert the possibly-space-containing input values
        var yritysKilot = yritysKilotInput ? toNumber(yritysKilotInput.value) : 0;
        var kuluttajaKilot = kuluttajaKilotInput ? toNumber(kuluttajaKilotInput.value) : 0;

        // Get price values
        var p1k = row.querySelector('.hintalaskuririvi__hinnat1 .company1-kuluttaja-price');
        var p1y = row.querySelector('.hintalaskuririvi__hinnat1 .company1-yritys-price');
        var p2k = row.querySelector('.hintalaskuririvi__hinnat2 .company2-kuluttaja-price');
        var p2y = row.querySelector('.hintalaskuririvi__hinnat2 .company2-yritys-price');

        // Convert to numbers or 0
        var company1KuluttajaPrice = p1k ? parsePrice(p1k.textContent) || 0 : 0;
        var company1YritysPrice    = p1y ? parsePrice(p1y.textContent) || 0 : 0;
        var company2KuluttajaPrice = p2k ? parsePrice(p2k.textContent) || 0 : 0;
        var company2YritysPrice    = p2y ? parsePrice(p2y.textContent) || 0 : 0;

        var out1 = row.querySelector('input[name="company1-kuluttaja"]');
        var out2 = row.querySelector('input[name="company1-yritys"]');
        var out3 = row.querySelector('input[name="company2-kuluttaja"]');
        var out4 = row.querySelector('input[name="company2-yritys"]');

        // Calculate values
        var c1KuluttajaResult = kuluttajaKilot * company1KuluttajaPrice;
        if (out1) {
            out1.value = c1KuluttajaResult.toLocaleString('fi-FI', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        }
        var c2KuluttajaResult = kuluttajaKilot * company2KuluttajaPrice;
        if (out3) {
            out3.value = c2KuluttajaResult.toLocaleString('fi-FI', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        }


        var c1YritysResult = yritysKilot * company1YritysPrice;
        if (out2) {
            out2.value = c1YritysResult.toLocaleString('fi-FI', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        }
        var c2YritysResult = yritysKilot * company2YritysPrice;
        if (out4) {
            out4.value = c2YritysResult.toLocaleString('fi-FI', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        }

    });

}




function calculateAll() {
    calculatePrices();
    calculateTotalsByMaterial();
    calculateTotalKilos();
    calculateTotalPrices();
}


function checkRadios() {
    const jasenyys = document.querySelectorAll('input[name="jasenyys"]:checked');
    const maara = document.querySelectorAll('input[name="maara"]:checked');
    const vertailu = document.querySelectorAll('input[name="vertailu"]:checked');

    const pakkaustyypitFieldset = document.querySelector('.pakkaustyypit-fieldset');
    const taulukko = document.querySelector('.hintalaskuri__taulukko');
    const yhteenveto = document.querySelector('.hintalaskuri__yhteenveto');
    const lataus = document.querySelector('.hintalaskuri__lataus');

    if (jasenyys.length > 0 && maara.length > 0 && vertailu.length > 0) {
        if (pakkaustyypitFieldset && pakkaustyypitFieldset.classList.contains('hidden')) {
            pakkaustyypitFieldset.classList.remove('hidden');
        }
        if (taulukko && taulukko.classList.contains('hidden')) {
            taulukko.classList.remove('hidden');
        }
        if (yhteenveto && yhteenveto.classList.contains('hidden')) {
            yhteenveto.classList.remove('hidden');
        }
        if (lataus && lataus.classList.contains('hidden')) {
            lataus.classList.remove('hidden');
        }

        calculateAll();
    }

}

function tarkistaMateriaalit() {
    const checkboxes = document.querySelectorAll('.pakkaustyypit input[name="materiaali"]');
    checkboxes.forEach(checkbox => {
        const value = checkbox.value;
        const targetDivs = document.querySelectorAll(`.hintalaskuri-${value}`);
        const yhteensaDiv = document.querySelector(`.yhteenveto-${value}`);

        targetDivs.forEach(targetDiv => {
            const hintaRivit = targetDiv.querySelectorAll('.hintalaskuririvi');
            const titles = targetDiv.querySelectorAll('.hintalaskuri__titlerow, .hintalaskuri__subtitlerow');

            if (checkbox.checked) {
                targetDiv.classList.add('showpdf');
                hintaRivit.forEach(el => el.classList.add('enabled'));
                titles.forEach(el => el.classList.add('show'));
            } else {
                targetDiv.classList.remove('showpdf');
                hintaRivit.forEach(el => {
                    el.classList.remove('enabled')
                    const kuluttajaInputs = el.querySelectorAll('input[name="kuluttajakilot"]');
                    const yritysInputs = el.querySelectorAll('input[name="yrityskilot"]');
                    kuluttajaInputs.forEach(input => input.value = '');
                    yritysInputs.forEach(input => input.value = '');
                });
                titles.forEach(el => el.classList.remove('show'));
            }
        });

        if (yhteensaDiv) {
            if (checkbox.checked) {
                yhteensaDiv.classList.add('enabled');
            } else {
                yhteensaDiv.classList.remove('enabled');
            }
        }


    });

    calculateAll();
}

function tarkistaJasenyys() {
    const rekisterointimaksu = document.querySelector('.hintalaskuririvi#rekisterointimaksu');

    if (rekisterointimaksu) {
        if (this.value === 'ei') {
            rekisterointimaksu.classList.add('enabled');
        } else {
            rekisterointimaksu.classList.remove('enabled');
        }
    }

    checkRadios();
}

function tarkistaMaara() {
    const laajat = document.querySelectorAll('.hintalaskuri__taulukko__ryhma.laaja');
    const kevennetyt = document.querySelectorAll('.hintalaskuri__taulukko__ryhma.kevennetty');

    if (laajat.length && kevennetyt.length) {
        if (this.value === 'yli') {
            laajat.forEach(el => el.classList.add('enabled'));
            kevennetyt.forEach(el => el.classList.remove('enabled'));
        } else {
            laajat.forEach(el => el.classList.remove('enabled'));
            kevennetyt.forEach(el => el.classList.add('enabled'));
        }
    }

    checkRadios();
}

function tarkistaVertailu() {
    const company2columns = document.querySelectorAll('.hintalaskuriotsikkorivi__company2');
    const hinnat2columns = document.querySelectorAll('.hintalaskuririvi__hinnat2');
    const yhteenvetoCompany2columns = document.querySelectorAll('.yhteenvetootsikkorivi__company2');
    const yhteenvetoHinnat2columns = document.querySelectorAll('.yhteenvetorivi__hinnat2');
    const yhteenvetoOtsikkoErocolumns = document.querySelectorAll('.yhteenvetootsikkorivi__ero');
    const yhteenvetoErocolumns = document.querySelectorAll('.yhteenvetorivi__ero');

    if (company2columns.length && hinnat2columns.length) {
        if (this.value === 'kylla') {
            company2columns.forEach(el => el.classList.remove('hidden'));
            hinnat2columns.forEach(el => el.classList.remove('hidden'));
            yhteenvetoCompany2columns.forEach(el => el.classList.remove('hidden'));
            yhteenvetoHinnat2columns.forEach(el => el.classList.remove('hidden'));
            yhteenvetoOtsikkoErocolumns.forEach(el => el.classList.remove('hidden'));
            yhteenvetoErocolumns.forEach(el => el.classList.remove('hidden'));
        } else {
            company2columns.forEach(el => el.classList.add('hidden'));
            hinnat2columns.forEach(el => el.classList.add('hidden'));
            yhteenvetoCompany2columns.forEach(el => el.classList.add('hidden'));
            yhteenvetoHinnat2columns.forEach(el => el.classList.add('hidden'));
            yhteenvetoOtsikkoErocolumns.forEach(el => el.classList.add('hidden'));
            yhteenvetoErocolumns.forEach(el => el.classList.add('hidden'));
        }
    }
/*

    if (laajat.length && kevennetyt.length) {
        if (this.value === 'yli') {
            laajat.forEach(el => el.classList.add('enabled'));
            kevennetyt.forEach(el => el.classList.remove('enabled'));
        } else {
            laajat.forEach(el => el.classList.remove('enabled'));
            kevennetyt.forEach(el => el.classList.add('enabled'));
        }
    } */

    checkRadios();
}

function resetFields(event) {
    const button = event.currentTarget;

    const group = button.closest('.hintalaskuri__taulukko__ryhma');
    if (!group) return;
    const inputs = group.querySelectorAll(
        'input[name="kuluttajakilot"], input[name="yrityskilot"]'
    );

    inputs.forEach(input => {
        input.value = '';
    });

    button.blur();

    calculateAll();
}

function hideEmptySections() {

    const hintalaskuri = document.querySelector('.hintalaskuri');

    if (hintalaskuri) {
        if (this.value === 'ei') {
            hintalaskuri.classList.remove('hideemptysections');
        } else {
            hintalaskuri.classList.add('hideemptysections');
        }
    }

}

let calcTimer;
function debounceCalc() {
    clearTimeout(calcTimer);
    calcTimer = setTimeout(() => {
        calculateAll();
    }, 150); // adjust delay if needed
}





document.addEventListener("DOMContentLoaded", function() {
    document.querySelectorAll('.pakkaustyypit input[name="materiaali"]').forEach(checkbox => {
        checkbox.addEventListener('change', tarkistaMateriaalit);
    });

    document.querySelectorAll('input[name="jasenyys"]').forEach(checkbox => {
        checkbox.addEventListener('change', tarkistaJasenyys);
    });

    document.querySelectorAll('input[name="maara"]').forEach(checkbox => {
        checkbox.addEventListener('change', tarkistaMaara);
    });

    document.querySelectorAll('input[name="vertailu"]').forEach(checkbox => {
        checkbox.addEventListener('change', tarkistaVertailu);
    });

    document.querySelectorAll('input[name="piilotatyhjat"]').forEach(checkbox => {
        checkbox.addEventListener('change', hideEmptySections);
    });

    document.querySelectorAll('button.tyhjennakentat').forEach(checkbox => {
        checkbox.addEventListener('click', resetFields);
    });

    document.addEventListener('keydown', function(e) {
        if (e.target && (e.target.name === 'yrityskilot' || e.target.name === 'kuluttajakilot')) {
            const allowed = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"];
            if (!/^[0-9]$/.test(e.key) && !allowed.includes(e.key)) {
                e.preventDefault();
                return;
            }
        }
    });

    document.addEventListener('input', function(e) {
        if (e.target && (e.target.name === 'yrityskilot' || e.target.name === 'kuluttajakilot')) {
            let oldCursor = e.target.selectionStart;
            let oldValue = e.target.value;

            // Count digits to the left of cursor
            let digitsBeforeCursor = oldValue.slice(0, oldCursor).replace(/\D/g, "").length;

            // Remove non-digits
            let raw = oldValue.replace(/\D/g, "");

            // Format with spaces every 3 digits
            let formatted = raw.replace(/\B(?=(\d{3})+(?!\d))/g, " ");

            // Set new cursor position
            let newCursor = 0;
            let digitCount = 0;
            for (let i = 0; i < formatted.length; i++) {
                if (/\d/.test(formatted[i])) digitCount++;
                if (digitCount >= digitsBeforeCursor) {
                    newCursor = i + 1;
                    break;
                }
            }

            // Apply formatted value and set cursor
            e.target.value = formatted;
            e.target.setSelectionRange(newCursor, newCursor);

            // Empty row handling
            let hintalaskuririvirow = e.target.closest('.hintalaskuririvi__container__row');
            let hintalaskuririvi = e.target.closest('.hintalaskuririvi');
            let ryhmacontainer = e.target.closest('.ryhmacontainer');
            let ryhma = e.target.closest('.hintalaskuri__taulukko__ryhma');
            let emptyclass = e.target.name === 'kuluttajakilot' ? 'emptykuluttaja' : 'emptyyritys';

            let isEmpty = e.target.value.trim() === "";
            hintalaskuririvirow.classList.toggle('emptyrow', isEmpty);
            hintalaskuririvi.classList.toggle(emptyclass, isEmpty);

            let bothEmpty = hintalaskuririvi.classList.contains('emptykuluttaja') && hintalaskuririvi.classList.contains('emptyyritys');
            ryhmacontainer.classList.toggle('emptyryhmacontainer', bothEmpty);
            ryhma.classList.toggle('emptyryhma', bothEmpty);

            debounceCalc();
        }
    });

    //VÄLIAIKAINEN
/*     const eiInput = document.querySelector('input[name="vertailu"][value="ei"]');
    if (eiInput) {
        eiInput.checked = true;
        eiInput.dispatchEvent(new Event('change', { bubbles: true }));
    } */


});
